export default __webpack_public_path__ + "static/media/avails-on-white.b66d1c02.png";